import React, { useState, useRef, useEffect } from 'react';

export default function ProjectMedia(props) {
    const [isContentLoaded, setIsContentLoaded] = useState(false);
    const [loadingPhrase, setLoadingPhrase] = useState('');
    const [background, setBackground] = useState();
    const [path, setPath] = useState();
    const vidRef = useRef(null);
    const [videoDimensions, setVideoDimensions] = useState({
        width: 0,
        height: 0,
    });

    const handleVideoMetadataLoaded = () => {
        if (vidRef.current) {
            setVideoDimensions({
                width: vidRef.current.videoWidth,
                height: vidRef.current.videoHeight,
            });
        }
    };

    //preloader
    const handleContentLoad = e => {
        setIsContentLoaded(true);
    };

    useEffect(() => {
        setPath(window.location.pathname.replace('/', ''));
    }, []);

    return (
        <div className={`${props.className} relative w-full overflow-hidden mt-2`}>
            <article
                className={`object-cover w-full h-full transition duration-500 overflow-hidden ease-out ${isContentLoaded ? 'opacity-100' : 'opacity-0'} ${background}`}>
                {props.isYouTube ? (
                    <iframe
                        className="w-full h-full aspect-video"
                        src={`https://www.youtube.com/embed/${new URLSearchParams(new URL(props.src).search).get('v')}`}
                        title="YouTube video"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        onLoad={handleContentLoad}
                    />
                ) : props.isVideo ? (
                    <video
                        ref={vidRef}
                        className={`object-cover overflow-hidden w-full h-full transition duration-1000 ease-out`}
                        playsInline
                        loop
                        autoPlay
                        muted
                        src={props.src}
                        onCanPlay={handleContentLoad}
                        onLoadedMetadata={handleVideoMetadataLoaded}
                    />
                ) : (
                    <img
                        alt="project hero"
                        className="object-cover w-full h-full transition duration-1000 ease-out"
                        src={props.src}
                        onLoad={handleContentLoad}
                    />
                )}
            </article>
        </div>
    );
}